export default /* glsl */ `void setFragmentColor(vec4 color) {
  gl_FragColor = color;
}`;
